import CookieName from '@core/constants/cookie/cookieNameConst';
import DatesFilterUtil from 'OldComponents/Analitics/DatesFilterUtil';
import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfYear,
  format,
  isSameDay,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear
} from 'date-fns';
import { FIELDER } from '@core/constants/base.constants';

const DEFAULT_DATES_FILTERS = [
  DatesFilterUtil.EXECUTION_PERIOD_TIME,
  DatesFilterUtil.EXECUTION_DATE,
  DatesFilterUtil.CREATION_DATE,
];
const datePresets = FIELDER.customDatePresets;

export const getObjectCookie = (cookieName, cookieObject) => {
	const body = {
		filterCookie: {
			cookieName,
		},
	};
	switch (cookieName) {
		case CookieName.MY_OPERATION_TASK_TABLE:
		case CookieName.DASHBOARD_TASK_SLA_TABLE:
			const cookiesRequest = [];
			Object.keys(cookieObject).map((key) => {
        const value = cookieObject[key];
        let active;
        let pinning = "";
        if (value && typeof value === 'object') {
          active = typeof value.active === 'boolean' ? value.active : !!value.active;
          pinning = value.pinning ?? "";
        } else {
          active = !!value;
        }
        cookiesRequest.push({ label: key, active, pinning });
        //cookiesRequest.push({ label: key, active: cookieObject[key] });
			});
			body.filterCookie.cookieTable = cookiesRequest;
			break;
		case CookieName.MY_OPERATION_TASK_TABLE_AVANCED_FILTER:
			body.filterCookie.advancedFiltersCookie = cookieObject;
			break;
    case CookieName.MY_OPERATION_DATES_FILTER:
      body.filterCookie.datesFilterCookie = cookieObject;
      break;
		case CookieName.DASHBOARD_TASK_SUMMARY_FILTER:
			body.filterCookie.dashboardSummaryTaskCookie = cookieObject;
			break;
    case CookieName.DOWNLOAD_EXPORT_TASK_COLUMNS:
      body.filterCookie.exportTaskColumnCookie = cookieObject;
      break;
		default:
			break;
	}
	return body;
};
export const extractNumeric = (v) => {
  if (typeof v === 'number') return Number.isFinite(v) ? v : NaN;
  if (typeof v === 'string') {
    const n = Number.parseInt(v, 10);
    return Number.isFinite(n) ? n : NaN;
  }
  if (v && typeof v === 'object') {
    if ('dateFilter' in v) return extractNumeric(v.dateFilter);
    if ('value' in v) return extractNumeric(v.value);
  }
  return NaN;
};
export const extractNumbersFromAnyArray = (arr) => {
  const out = [];
  const walk = (a) => {
    a.forEach((item) => {
      if (Array.isArray(item)) return walk(item);
      const n = extractNumeric(item);
      if (Number.isFinite(n)) out.push(n);
    });
  };
  walk(arr);
  return out;
};
export const formatDateForCookie = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
};
export const parseDateFromCookie = (value) => {
  const formatted = formatDateForCookie(value);
  if (!formatted) return null;
  const parsed = new Date(formatted);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};
export const isCookiePayloadObject = (value) => value && typeof value === 'object' && !Array.isArray(value);
export const extractPresetFromCookiePayload = (payload) => {
  if (!isCookiePayloadObject(payload)) return undefined;
  const { customDateParam } = payload;
  return typeof customDateParam === 'string' && customDateParam.trim() ? customDateParam : undefined;
};
export const extractSearchFunctionalityFromCookiePayload = (payload) => {
  if (!isCookiePayloadObject(payload)) return undefined;
  const { searchFunctionalityParam } = payload;
  return typeof searchFunctionalityParam === 'string' && searchFunctionalityParam.trim() ? searchFunctionalityParam : undefined;
};
export const extractFunctionalityFilterParamsFromCookiePayload = (payload) => {
  if (!isCookiePayloadObject(payload)) return undefined;
  const { functionalityFilterParams } = payload;
  return typeof functionalityFilterParams === 'string' && functionalityFilterParams.trim()
    ? functionalityFilterParams.trim()
    : undefined;
};
export const extractDateFromCookiePayload = (payload, key) => {
  if (!isCookiePayloadObject(payload)) return null;
  return formatDateForCookie(payload[key]);
};
export const buildDatesFilterCookiePayload = (
  filterValues,
  { preset, startDate, endDate, searchFunctionality, functionalityFilterParams } = {},
) => {
  const normalizedValues = Array.isArray(filterValues) ? filterValues : [];
  const presetToUse = typeof preset === 'string' && preset.trim() ? preset : datePresets.DAY;
  const functionalityParam =
    typeof searchFunctionality === 'string' && searchFunctionality.trim()
      ? searchFunctionality.trim()
      : null;
  const functionalityFilterParam =
    typeof functionalityFilterParams === 'string' && functionalityFilterParams.trim()
      ? functionalityFilterParams.trim()
      : null;
  const payload = {
    customDateParam: presetToUse,
    datesFilterValues: normalizedValues.map((value) => ({ dateFilter: value })),
    startDate: null,
    endDate: null,
    searchFunctionalityParam: functionalityParam,
    functionalityFilterParams: functionalityFilterParam,
  };
  if (presetToUse === datePresets.CUSTOM) {
    payload.startDate = startDate ?? null;
    payload.endDate = endDate ?? null;
  }
  return payload;
};
export const toValidDatesFilterArray = (values) => {
  if (!Array.isArray(values)) return [];
  const nums = extractNumbersFromAnyArray(values);
  const allowed = new Set(DEFAULT_DATES_FILTERS);
  const seen = new Set();
  return DEFAULT_DATES_FILTERS.filter((opt) => {
    if (nums.includes(opt) && !seen.has(opt) && allowed.has(opt)) {
      seen.add(opt);
      return true;
    }
    return false;
  });
};
export const decodeDatesFilterCookie = (payload) => {
  if (payload == null) return [...DEFAULT_DATES_FILTERS];
  if (typeof payload === 'string') {
    const trimmed = payload.trim();
    if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
      try {
        return decodeDatesFilterCookie(JSON.parse(trimmed));
      } catch (_) {
        // fall through
      }
    }
    const asNum = Number.parseInt(trimmed, 10);
    if (Number.isFinite(asNum)) return decodeDatesFilterCookie(asNum);
    return [...DEFAULT_DATES_FILTERS];
  }
  if (Array.isArray(payload)) {
    const normalized = toValidDatesFilterArray(payload);
    return normalized.length > 0 ? normalized : [...DEFAULT_DATES_FILTERS];
  }
  if (typeof payload === 'object') {
    if (Array.isArray(payload.datesFilterValues)) return decodeDatesFilterCookie(payload.datesFilterValues);
    if ('datesFilterCookie' in payload) return decodeDatesFilterCookie(payload.datesFilterCookie);
    if ('datesFilterType' in payload) return decodeDatesFilterCookie(payload.datesFilterType);
    if ('value' in payload) return decodeDatesFilterCookie(payload.value);
    if (Array.isArray(payload.value)) return decodeDatesFilterCookie(payload.value);
  }
  if (typeof payload === 'number' && Number.isFinite(payload)) {
    if (payload <= 0) return [...DEFAULT_DATES_FILTERS];
    const mask = payload;
    const selected = DEFAULT_DATES_FILTERS.filter((opt) => (mask & (1 << opt)) !== 0);
    return selected.length > 0 ? selected : [...DEFAULT_DATES_FILTERS];
  }
  // Fallback
  return [...DEFAULT_DATES_FILTERS];
};
export const buildPresetRange = (preset, referenceDate = new Date()) => {
  let start = null;
  let end = null;
  switch (preset) {
    case FIELDER.customDatePresets.DAY:
      start = startOfDay(referenceDate);
      end = endOfDay(referenceDate);
      break;
    case FIELDER.customDatePresets.WEEK:
      start = startOfWeek(referenceDate);
      end = endOfWeek(referenceDate);
      break;
    case FIELDER.customDatePresets.MONTH:
      start = startOfMonth(referenceDate);
      end = endOfMonth(referenceDate);
      break;
    case FIELDER.customDatePresets.YEAR:
      start = startOfYear(referenceDate);
      end = endOfYear(referenceDate);
      break;
    default:
      break;
  }
  return { start, end };
};
export const resolveRangeForPreset = (preset, currentRange, referenceDate = new Date()) => {
  if (preset === FIELDER.customDatePresets.CUSTOM) {
    return {
      start: currentRange?.[0] ?? null,
      end: currentRange?.[1] ?? null,
    };
  }
  if (currentRange?.[0] && currentRange?.[1]) {
    return {
      start: currentRange[0],
      end: currentRange[1],
    };
  }
  return buildPresetRange(preset, referenceDate);
};
export const formatRangeLabel = (start, end, locale) => {
  if (!start && !end) return null;
  if (start && end) {
    if (isSameDay(start, end)) return format(start, 'P', { locale });
    return `${format(start, 'P', { locale })} – ${format(end, 'P', { locale })}`;
  }
  const date = start ?? end;
  return date ? format(date, 'P', { locale }) : null;
};
